var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnchor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    viewBox: "0 96 960 960",
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480 989.001q-73.913 0-140.957-25.131-67.044-25.13-118.105-66.839-51.061-41.709-80.804-95.348-29.743-53.64-29.743-110.292V584.608l159.305 119.653-60.261 60.261Q239.87 818 307.239 859.826q67.37 41.826 133.152 46.261V542.392h-130v-79.218h130v-64.956q-42.522-17.392-64.37-48.501-21.848-31.108-21.848-69.935 0-53.065 37.155-90.011t88.805-36.946q52.65 0 89.455 36.946 36.804 36.946 36.804 90.011 0 38.827-22.219 69.951-22.218 31.124-64.564 48.485v64.956h130v79.218h-130v363.695q65.782-4.435 133.152-46.261Q720.13 818 750.565 764.522l-60.261-60.261 159.305-119.653v106.783q0 56.652-29.743 110.292-29.743 53.639-80.804 95.348-51.061 41.709-118.105 66.839Q553.913 989.001 480 989.001Zm.06-662.61q19.583 0 33.066-14.042 13.483-14.042 13.483-32.626 0-19.824-13.543-33.469-13.542-13.645-33.126-13.645-18.583 0-32.566 13.701-13.983 13.702-13.983 33.522 0 18.82 14.043 32.689 14.042 13.87 32.626 13.87Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnchor);
export default __webpack_public_path__ + "static/media/anchor.bb973708f7c379101c190696f1d709cc.svg";
export { ForwardRef as ReactComponent };